(function () {
  'use strict';

  angular.module('unit.info').directive('fastDeal', fastDeal);

  function fastDeal() {
    var directive = {
      bindToController: true,
      controller: 'FastDealCtrl',
      template: require('./fast.deal.html'),
      link: link,
      restrict: 'AE',
      scope: {
        unit: '=',
        onSubmit: '&',
      },
    };

    return directive;

    function link(scope, element, attr) {}
  }
})();
